var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5013 6.99997C21.5013 6.80106 21.4223 6.61029 21.2817 6.46964C21.141 6.32899 20.9503 6.24997 20.7513 6.24997H3.06184L7.78234 1.53097C7.85207 1.46124 7.90739 1.37846 7.94513 1.28735C7.98286 1.19624 8.00229 1.09859 8.00229 0.999971C8.00229 0.901355 7.98286 0.803705 7.94513 0.712596C7.90739 0.621487 7.85207 0.538703 7.78234 0.468971C7.71261 0.399239 7.62983 0.343925 7.53872 0.306186C7.44761 0.268447 7.34996 0.249023 7.25134 0.249023C7.15272 0.249023 7.05507 0.268447 6.96396 0.306186C6.87286 0.343925 6.79007 0.399239 6.72034 0.468971L0.720341 6.46897C0.650496 6.53864 0.595082 6.6214 0.557272 6.71252C0.519462 6.80364 0.5 6.90132 0.5 6.99997C0.5 7.09862 0.519462 7.1963 0.557272 7.28742C0.595082 7.37854 0.650496 7.4613 0.720341 7.53097L6.72034 13.531C6.79007 13.6007 6.87286 13.656 6.96396 13.6938C7.05507 13.7315 7.15272 13.7509 7.25134 13.7509C7.34996 13.7509 7.44761 13.7315 7.53872 13.6938C7.62983 13.656 7.71261 13.6007 7.78234 13.531C7.85207 13.4612 7.90739 13.3785 7.94513 13.2873C7.98286 13.1962 8.00229 13.0986 8.00229 13C8.00229 12.9014 7.98286 12.8037 7.94513 12.7126C7.90739 12.6215 7.85207 12.5387 7.78234 12.469L3.06184 7.74997H20.7513C20.9503 7.74997 21.141 7.67095 21.2817 7.5303C21.4223 7.38965 21.5013 7.19888 21.5013 6.99997Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.3645f94ec7af5ebf0736ff914d31fa05.svg";
export { ForwardRef as ReactComponent };